import { MarketingPreferences } from 'cpie-common';
import { AbstractDataState, useGetSimpleApiData } from '@cp-shared-15/frontend-integration';
import { fetchMarketingPreferences } from './MarketingPreferencesSlice';
import { MarketingPreferencesDataSelector } from './MarketingPreferencesDataSelector';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-15/common-utilities';

export function useMarketingPreferences(): AbstractDataState<MarketingPreferences, DefaultBusinessMarketApiErrorCode> {
    return useGetSimpleApiData(fetchMarketingPreferences, MarketingPreferencesDataSelector);
}
